// import { useEffect } from "react"
// import { InteractionManager } from "react-native"

// export const useInteractionsManager = ({
//     allow = true,
//     func = () => {},
//     deps = []
// }: {
//     allow?: boolean,
//     func: () => any
//     deps?: any[]
// }) => {
    
//     useEffect(() => {
//         if(!allow)
//             return;
//         const task = InteractionManager.runAfterInteractions(func)
//         return () => task.cancel()
//     }, deps)
// }

import { useEffect, useRef } from "react";
import { InteractionManager } from "react-native";

export const useInteractionsManager = ({
  allow = true,
  func,
  deps = [],
}: {
  allow?: boolean;
  func: () => void;
  deps?: any[];
}) => {
  const latestFunc = useRef(func);

  // ✅ всегда держим актуальную функцию
  useEffect(() => {
    latestFunc.current = func;
  }, [func]);

  useEffect(() => {
    if (!allow) return;

    const task = InteractionManager.runAfterInteractions(() => {
      latestFunc.current();
    });

    return () => task.cancel();
  }, [allow, ...deps]); // ✅ allow всегда в deps
};
